import { inject, Injectable, Provider } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { PageTitleService } from './page-title.service';

/**
 * Route `title`s in `app.routes.ts` are i18n keys, not display text. This
 * strategy hands the deepest one to `PageTitleService`, which translates it
 * and applies the suffix, instead of Angular writing the raw key to the tab.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  private readonly pageTitleService = inject(PageTitleService);

  public override updateTitle(snapshot: RouterStateSnapshot): void {
    this.pageTitleService.setRouteTitleKey(this.buildTitle(snapshot));
  }
}

export const providePageTitleStrategy = (): Provider => ({
  provide: TitleStrategy,
  useExisting: PageTitleStrategy,
});
